module.exports = __webpack_public_path__ + "eaf5e30d6013dcbf907a97df9bc04f69.svg";